module.exports = __webpack_public_path__ + "img/3.7fbd3f5d.webp";